module.exports = __webpack_public_path__ + "img/job-medium.9d8bbe7f.svg";